const pre = '/chainmaker/';

export default {
    path: '/chainmaker',
    title: 'ChainMaker',
    header: '',
    icon: 'md-link',
    children: [
        {
            path: `${pre}org`,
            title: '组织列表'
        },
        {
            path: `${pre}management`,
            title: '链管理'
        },
        {
            path: `${pre}explorer`,
            title: '区块浏览器'
        },

    ]
}
